import { isHorizonRootRole } from "./horizonRoles";

/**
 * LaunchDarkly gate for Deep Research and the analytics assistant.
 * The client SDK is configured with camelCase keys off, and older readers also
 * accept the camelCase and kebab-case spellings useFlags has returned.
 */
export const ANALYTICS_ASSISTANT_FLAG_KEYS = [
  "analyticsassistant",
  "analyticsAssistant",
  "analytics-assistant",
  "analytics_assistant",
] as const;

function isLdFlagEnabled(flags: Record<string, unknown>, ...keys: string[]): boolean {
  for (const key of keys) {
    const value = flags[key];
    if (value === true) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "on" || normalized === "yes" || normalized === "1") {
        return true;
      }
    }
  }
  return false;
}

export function isAnalyticsAssistantLdEnabled(flags: Record<string, unknown>): boolean {
  return isLdFlagEnabled(flags, ...ANALYTICS_ASSISTANT_FLAG_KEYS);
}

/** Flag on, or a Horizon root user. Root keeps the access the reports page already had. */
export function canAccessAnalyticsAssistant(
  flags: Record<string, unknown>,
  role?: string | null
): boolean {
  return isAnalyticsAssistantLdEnabled(flags) || isHorizonRootRole(role);
}
